import Typography from '@/app/components/typography'
import { cn } from '@/util/cn'
import ChevronLeftIcon from '@/components/icons/chevron-left-icon'
import ChevronRightIcon from '@/components/icons/chevron-right-icon'

type Props = {
    isDisabled: boolean
    onPrev: () => void;
    onNext: () => void;
}

const buttonClassName = cn('flex gap-3 flex-row items-center cursor-pointer')

const SlideDesktopNavigation = ({ isDisabled, onPrev, onNext }: Props) => (
    <div className="flex justify-between items-center w-full absolute bottom-6 mt-auto px-10">
        <button className={buttonClassName} onClick={onPrev} disabled={isDisabled}>
            <ChevronLeftIcon className="size-[0.8rem]" />
            
            <Typography fontWeight="bold" variant="text-lg" className="opacity-75">Prev</Typography>
        </button>

        <button className={buttonClassName} onClick={onNext} disabled={isDisabled}>
            <Typography fontWeight="bold" variant="text-lg" className="opacity-75">Next</Typography>

            <ChevronRightIcon className="size-[0.8rem]" />
        </button>
    </div>
)

export default SlideDesktopNavigation
